import * as log from 'loglevel';

export const LOGGER = log;
